function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default {
  install: function install(Vue, options) {
    Vue.prototype.updatables = {};
    Vue.mixin({
      created: function created() {
        var spec = this.spec;

        if (spec && spec.id) {
          Object.assign(this.updatables, _defineProperty({}, spec.id, this));
        }
      }
    });
  }
};